const FEATURES = {
  starter: [
    "Remove Storydoc branding",
    "Export to PDF",
    "5 active documents",
    "20/month AI Image credits",
    "25/month AI Text credits",
    "Analytics",
    "Interactive slides and templates",
  ],
  pro: [
    "Remove Storydoc branding",
    "Export to PDF",
    "Collaboration",
    "Integrations",
    "Personalization with variables",
    "Folder management",
    "Analytics",
    "30 active documents",
    "Image & text AI credits",
    "Version control",
  ],
};

export { FEATURES };
